/* Turbo Parts — smooth Shopify forms.
 * Makes the email-signup (10% off) and the Contact form submit WITHOUT a page
 * reload or jump, showing an inline confirmation in place.
 *
 * Technique: submit the real Shopify form into a hidden iframe. The POST still
 * happens server-side (so the email is captured / the message is delivered, and
 * Shopify's own spam-protection token still rides along), but the visible page
 * never navigates or scrolls. When the response returns we show a tidy inline
 * message. The "#contact_form" anchor is also stripped so nothing can scroll.
 */
(function () {
  'use strict';
  var SINK = 'tp-form-sink';

  function sink() {
    var f = document.getElementById(SINK);
    if (!f) {
      f = document.createElement('iframe');
      f.id = SINK;
      f.name = SINK;
      f.setAttribute('aria-hidden', 'true');
      f.setAttribute('tabindex', '-1');
      f.style.cssText = 'position:absolute;left:-9999px;top:0;width:0;height:0;border:0;';
      document.body.appendChild(f);
    }
    return f;
  }

  function showOk(form, html) {
    var b = form.querySelector('.tp-form-ok');
    if (!b) {
      b = document.createElement('div');
      b.className = 'tp-form-ok';
      b.setAttribute('role', 'status');
      form.appendChild(b);
    }
    b.innerHTML = html;
    b.style.cssText =
      'margin-top:12px;padding:11px 14px;border-radius:10px;font-size:14px;font-weight:600;' +
      'background:#E7F4EC;color:#1E7A3C;border:1px solid #B7E0C4;text-align:center;';
  }

  function kindOf(form) {
    var ft = form.querySelector('input[name="form_type"]');
    var type = ft ? ft.value : '';
    var action = form.getAttribute('action') || '';
    if (type === 'contact') return 'contact';
    if (type === 'customer') return 'signup';
    if (action.indexOf('/contact') === 0 && form.querySelector('input[type="email"], [name*="email" i]')) return 'signup';
    return null;
  }

  function enhance(form) {
    if (form.dataset.tpSmooth) return;
    var kind = kindOf(form);
    if (!kind) return;
    form.dataset.tpSmooth = '1';

    sink();
    form.setAttribute('target', SINK);
    var action = form.getAttribute('action') || '/contact';
    form.setAttribute('action', action.split('#')[0]); // drop #anchor -> no scroll jump

    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"], input[type="submit"], button');
      var label = null;
      if (btn) {
        label = (btn.textContent != null && btn.tagName === 'BUTTON') ? btn.textContent : btn.value;
        if (btn.tagName === 'BUTTON') btn.textContent = 'Sending…'; else btn.value = 'Sending…';
        btn.disabled = true;
      }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        showOk(form, kind === 'signup'
          ? '🎉 You’re in! Use code <strong>WELCOME10</strong> for 10% off your first order.'
          : '✓ Thanks — your message has been sent. We’ll get back to you shortly.');
        try { form.reset(); } catch (e) {}
        if (btn) {
          btn.disabled = false;
          if (btn.tagName === 'BUTTON') btn.textContent = label || 'Send'; else btn.value = label || 'Send';
        }
      }
      var fr = document.getElementById(SINK);
      fr.addEventListener('load', finish, { once: true }); // fires when Shopify responds
      setTimeout(finish, 2600);                            // safety fallback
    });
  }

  function scan() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) enhance(forms[i]);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  // popups / async sections may inject forms after load
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
